import React from "react";
import { Button } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const HomeButton: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Button
      type="default"
      icon={<HomeOutlined />}
      onClick={() => navigate("/")}
      className="mb-4 h-full"
    >
      Home
    </Button>
  );
};

export default HomeButton;
